import { useState, useEffect, useRef, useCallback } from 'react';
import { useAppSelector } from './redux';
import { socialService } from '../services/socialService';

const POLL_INTERVAL = 30_000; // 30 seconds

export function useUnreadMessages() {
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const [unreadCount, setUnreadCount] = useState(0);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const fetchUnread = useCallback(async () => {
    if (!isAuthenticated) return;
    try {
      const count = await socialService.getUnreadMessageCount();
      setUnreadCount(count);
    } catch {
      // silent
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) {
      setUnreadCount(0);
      return;
    }
    fetchUnread();
    timerRef.current = setInterval(fetchUnread, POLL_INTERVAL);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [isAuthenticated, fetchUnread]);

  return unreadCount;
}
